/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadInteractionTyeFromJSON, ApiLeadInteractionTyeToJSON, } from './ApiLeadInteractionTye';
import { ApiLeadStatusTypeFromJSON, ApiLeadStatusTypeToJSON, } from './ApiLeadStatusType';
export function ApiLeadInteractionPayloadFromJSON(json) {
    return ApiLeadInteractionPayloadFromJSONTyped(json, false);
}
export function ApiLeadInteractionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dfKey': !exists(json, 'dfKey') ? undefined : json['dfKey'],
        'leadKey': !exists(json, 'leadKey') ? undefined : json['leadKey'],
        'stageKey': !exists(json, 'stageKey') ? undefined : json['stageKey'],
        'status': !exists(json, 'status') ? undefined : ApiLeadStatusTypeFromJSON(json['status']),
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'type': !exists(json, 'type') ? undefined : ApiLeadInteractionTyeFromJSON(json['type']),
    };
}
export function ApiLeadInteractionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dfKey': value.dfKey,
        'leadKey': value.leadKey,
        'stageKey': value.stageKey,
        'status': ApiLeadStatusTypeToJSON(value.status),
        'subject': value.subject,
        'type': ApiLeadInteractionTyeToJSON(value.type),
    };
}
